import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import fr from 'date-fns/locale/fr'
import { Calendar } from '~/components/ui/calendar'
import { useBookingVisitStore } from '../space-visit.store'

export const DayStep = () => {
	const day = useBookingVisitStore.use.day()
	const setDay = useBookingVisitStore.use.setDay()
	const setStep = useBookingVisitStore.use.setStep()

	return (
		<Calendar
			locale={fr}
			showOutsideDays
			fixedWeeks
			fromDate={dateTimeUtils().toDate()}
			classNames={{
				day_outside: 'opacity-50',
				months: 'flex flex-row gap-4',
				head_cell: 'text-xs h-[42px] !w-[42px] font-normal opacity-50',
				cell: '!h-[42px] w-[42px]',
				button:
					'!text-xs rounded-full h-[42px] w-[42px] flex items-center justify-center cursor-pointer',
			}}
			className='mx-auto'
			selected={new Date(day)}
			onSelect={(d) => {
				setDay(dateTimeUtils(d).format('YYYY-MM-DD'))
				setStep('startTime')
			}}
			mode='single'
		/>
	)
}
